<script setup lang="ts">
const { t } = useI18n()

useHead({
  link: [{
    rel: 'canonical',
    href: `${import.meta.env.VITE_MONOLITH_URL}/careers`,
  }],
})

useSeoMeta({
  title: t('careers.meta.title'),
  description: t('careers.meta.description'),
  ogTitle: t('careers.meta.title'),
  ogDescription: t('careers.meta.description'),
  ogImage: `${S3_ASSETS_URL}/meta-default.jpg`,
})
</script>

<template>
  <div class="isolate">
    <LayoutNavbar />

    <div
      class="mb-0 bg-gradient-to-b from-[#f8f8f0] from-50% to-white p-4 md:mb-8 md:rounded-b-[5rem] md:shadow-2xl md:shadow-black/10 lg:mb-16"
    >
      <section class="mx-auto mb-8 max-w-screen-sm lg:max-w-screen-xl">
        <CareersJoinTheTeam />
      </section>

      <section
        class="mx-auto max-w-screen-xl rounded-[1.75rem] border border-neutral-200 bg-white px-4 py-6 md:px-8 md:py-10"
      >
        <CareersWhoWeAre />
        <CareersWhyJoinUs />
      </section>

      <section class="mx-auto max-w-screen-xl px-0 py-6 md:px-8 md:py-10">
        <CareersHowWeWork />
      </section>
    </div>

    <LayoutFooter />
  </div>
</template>
